import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { fetchWithCSRFTokenForRequestObject } from "Utils/fetchWithCSRFToken";

import { CompanyContributionsUpdate, UpdateCompanyContributionsResponse, EmployerCompanyPolicy, ChurnScheduleStatus } from "./companyPolicy.types";

export const companyPolicyApi = createApi({
  reducerPath: "companyPolicyApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/v2",
    fetchFn: fetchWithCSRFTokenForRequestObject,
  }),
  refetchOnMountOrArgChange: true,
  tagTypes: ["CompanyPolicy", "CompanyContributions", "ChurnSchedule"],
  endpoints: (builder) => ({
    // GET /api/v2/company_policies/:companyPolicyId
    getCompanyPolicy: builder.query<EmployerCompanyPolicy, { companyPolicyId: string }>({
      query: ({ companyPolicyId, ...params }) => ({
        url: `/company_policies/${companyPolicyId}`,
        method: "GET",
        params: {
          include: "companyContributions",
          ...params,
        },
      }),
      providesTags: ["CompanyPolicy"],
    }),
    // PUT /api/v2/company_policies/:companyPolicyId/company_contributions
    updateCompanyContributions: builder.mutation<UpdateCompanyContributionsResponse, { companyPolicyId: string; data: CompanyContributionsUpdate }>({
      query: ({ companyPolicyId, data }) => ({
        url: `/company_policies/${companyPolicyId}/company_contributions`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["CompanyPolicy", "CompanyContributions"],
    }),
    // GET /api/v2/company_policies/:companyPolicyId/churn_schedule
    getChurnSchedule: builder.query<ChurnScheduleStatus, { companyPolicyId: string }>({
      query: ({ companyPolicyId }) => ({
        url: `/company_policies/${companyPolicyId}/churn_schedule`,
        method: "GET",
      }),
      providesTags: ["ChurnSchedule"],
    }),
  }),
});

export const { useGetCompanyPolicyQuery, useUpdateCompanyContributionsMutation, useGetChurnScheduleQuery } = companyPolicyApi;
